import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

interface LinkIconProps extends SvgIconProps {
  disabled?: boolean;
}

const LinkIcon = (props: LinkIconProps) => {
  const { className, disabled, ...otherProps } = props;
  const fillColor = disabled ? 'rgba(255, 255, 255, 0.38)' : 'white';

  return (
    <SvgIcon {...otherProps} className={className || ''} viewBox="0 0 16 16">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.3334 4.66675H8.66671V6.00008H11.3334C12.4334 6.00008 13.3334 6.90008 13.3334 8.00008C13.3334 9.10008 12.4334 10.0001 11.3334 10.0001H8.66671V11.3334H11.3334C13.1734 11.3334 14.6667 9.84008 14.6667 8.00008C14.6667 6.16008 13.1734 4.66675 11.3334 4.66675ZM7.33337 10.0001H4.66671C3.56671 10.0001 2.66671 9.10008 2.66671 8.00008C2.66671 6.90008 3.56671 6.00008 4.66671 6.00008H7.33337V4.66675H4.66671C2.82671 4.66675 1.33337 6.16008 1.33337 8.00008C1.33337 9.84008 2.82671 11.3334 4.66671 11.3334H7.33337V10.0001ZM5.33337 7.33342H10.6667V8.66675H5.33337V7.33342Z"
        fill={fillColor}
      />
    </SvgIcon>
  );
};

export default LinkIcon;
